import { createContext } from "react";

export const HadeethContext = createContext();